import { useContext, useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';

/**
 * A route wrapper that checks if the selected account has completed onboarding.
 * If onboarding is not complete, redirects to /onboard/:accountId.
 */
export default function RequireOnboardingComplete() {
  const { slug } = useParams<{ slug: string }>();
  const { accounts } = useContext(UserContext);
  const [isChecking, setIsChecking] = useState(true);

  const selectedAccount = accounts?.find((a) => a.data().slug === slug);

  useEffect(() => {
    // Wait for accounts to load
    if (accounts !== undefined) {
      setIsChecking(false);
    }
  }, [accounts]);

  // Still loading accounts
  if (isChecking) {
    return null;
  }

  // Account not found - let normal routing handle this
  if (!selectedAccount) {
    return <Outlet />;
  }

  // const accountData = selectedAccount.data();
  // const onboardStatus = accountData.onboardStatus;

  // If onboarding is not completed (undefined, 'not-started', or 'in-progress'), redirect to onboard
  // if (onboardStatus !== 'completed') {
  //   return <Navigate to={`/onboard/${selectedAccount.id}`} replace />;
  // }

  return <Outlet />;
}
